import * as types from './actionTypes';

const initalState = {
  customerList: [],
  editCustomerSuccess: false,
};

export const CustomerReducer = (state = initalState, action) => {
  const { type } = action;
  switch (type) {
    case types.SET_CUSTOMER_LIST:
      return {
        ...state,
        customerList: action.payload,
      };

    case types.EDIT_CUSTOMER_SUCCESS:
      return {
        ...state,
        editCustomerSuccess: action.payload,
      };

    default:
      return state;
  }
};
